/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * A renderless component which provides data
 * by index. Stores the selected index in internal state
 * and updates the index through an ```onSelectIndex``` handler.
 *
 * @returns {IndexData} The IndexData
 */
var IndexData = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(IndexData, _React$PureComponent);
  var _super = _createSuper(IndexData);
  function IndexData(props) {
    var _this;
    _classCallCheck(this, IndexData);
    _this = _super.call(this, props);
    /**
     * Handles a change in selected index.
     *
     * @param {number} selectedIndex The new selected index
     * @returns {void}
     */
    _defineProperty(_assertThisInitialized(_this), "handleSelectIndex", function (selectedIndex) {
      if (selectedIndex === _this.state.selectedIndex) {
        return;
      }
      _this.setState({
        selectedIndex: selectedIndex
      }, function () {
        _this.props.onSelectIndex && _this.props.onSelectIndex(selectedIndex);
      });
    });
    _this.state = {
      selectedIndex: props.selectedIndex || 0
    };
    return _this;
  }
  _createClass(IndexData, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        data = _this$props.data;
      var selectedIndex = this.state.selectedIndex;
      return children && children({
        onSelectIndex: this.handleSelectIndex,
        selectedData: data && data[selectedIndex],
        selectedIndex: selectedIndex
      });
    }
  }]);
  return IndexData;
}(_react["default"].PureComponent);
IndexData.propTypes = {
  /** React children */
  children: _propTypes["default"].func,
  /**
   * An optional array of data to match
   * the indexes being used. If provided,
   * the data entry matching the currently
   * selected index will be passed down to
   * the children.
   */
  data: _propTypes["default"].array,
  /**
   * An optional external handler to be
   * notified about index changes.
   * Will be triggered on all index changes.
   */
  onSelectIndex: _propTypes["default"].func,
  /**
   * The initially selected index.
   */
  selectedIndex: _propTypes["default"].number
};
var _default = IndexData;
exports["default"] = _default;